import { Section } from "../components/Section";
import { ProjectCard } from "../components/ProjectCard";

export function Projects() {
  return (
    <Section id="projects" label="other projects" title="other projects">
      <div className="mt-6">
        <ProjectCard
          name="Does Pupper Suffer"
          url="doespuppersuffer.com"
          href="https://doespuppersuffer.com"
        >
          doesthedogdie.com is great for catching triggers but it's also lousy with spoilers. Since
          they're nice enough to make a public API available, this service just wraps that public
          API and is explicit about exactly which triggers it filters for — namely just the things
          that we care about.
        </ProjectCard>
      </div>
    </Section>
  );
}
